import React from 'react'
import { useParams } from 'react-router'
import { ReplyContextProvider } from '@components/ReplyToMessageContext/ReplyToMessageProvider'
import { isDMChannelStreamId, isGDMChannelStreamId } from '@towns-protocol/sdk'
import { ChannelContextProvider } from 'use-towns-client'

export const SpaceChannelWrapper = (
    props: { children: React.ReactElement } & { channelId?: string },
) => {
    const { channelSlug } = useParams()
    const channelId = props.channelId ?? channelSlug
    const isDmOrGDM =
        channelId && (isDMChannelStreamId(channelId) || isGDMChannelStreamId(channelId))

    if (!channelId) {
        return <>SpacesChannel Route expects a channelSlug</>
    }
    return (
        <ChannelContextProvider channelId={channelId}>
            <ReplyContextProvider canReplyInline key={channelId} canReplyInThread={!isDmOrGDM}>
                {props.children}
            </ReplyContextProvider>
        </ChannelContextProvider>
    )
}
